import React, { Key, ReactNode } from "react";

import { AdditionalQuestionModal } from "manager/components/Modal";
import {
  useGetDealSetup,
  useUpdateDealSetup,
} from "manager/hooks/api/dealSetupQueries";
import { CONTENT_TYPE } from "shared/config/constants";
import useModal from "shared/hooks/useModal";

import DealSetupForm from "../DealSetupForm";

interface PortfolioDealSetupSettingsContainerProps {
  children: ReactNode | ReactNode[];
  dealSetupId: Key;
  isVeroGoActive?: boolean;
}

const PortfolioDealSetupSettingsContainer = ({
  children,
  dealSetupId,
  isVeroGoActive,
}: PortfolioDealSetupSettingsContainerProps) => {
  const { openModalDialog } = useModal();

  const { updateDealSetup } = useUpdateDealSetup();

  const saveChanges = (
    values: { id: number; data: any },
    resolve: () => void,
    reject: () => void
  ) => {
    updateDealSetup(
      // @ts-ignore
      { id: values.id, dealSetup: values.data },
      { onSuccess: resolve, onError: reject }
    );
  };

  const { dealSetup, isDealSetupLoading, isDealSetupFetching } =
    useGetDealSetup(dealSetupId);

  const openQuestionsModal = (context) =>
    openModalDialog(AdditionalQuestionModal, {
      forSettingsLabel: "Portfolio Settings",
      contentType: CONTENT_TYPE.dealSetup,
      ...context,
    });

  return (
    // @ts-ignore
    <DealSetupForm
      forSettingsLabel="Portfolio Settings"
      saveChanges={saveChanges}
      dealSetup={dealSetup}
      loading={isDealSetupLoading}
      fetching={isDealSetupFetching}
      openQuestionsModal={openQuestionsModal}
      isVeroGoActive={isVeroGoActive}
    >
      {children}
    </DealSetupForm>
  );
};

export default PortfolioDealSetupSettingsContainer;
